// Single source of truth for the hunch.mt embed origin. Used by all
// three embed components (legacy bundled + main + strip) for both the
// iframe `src` and the `postMessage` origin check.
//
// Switch to 'https://hunch.mt' once production DNS is configured.
export const HUNCH_ORIGIN = 'https://hunch.up.railway.app';

export interface HunchHeightMessage {
  type: 'hunch:embed:height';
  height: number;
}

export function isHunchHeightMessage(data: unknown): data is HunchHeightMessage {
  if (typeof data !== 'object' || data === null) return false;
  const m = data as { type?: unknown; height?: unknown };
  return (
    m.type === 'hunch:embed:height' &&
    typeof m.height === 'number' &&
    m.height > 0
  );
}
